module.exports = __webpack_public_path__ + "img/37.7ca1f15d.jpg";